import { sha256 } from 'hash.js';

/// Uses sha256 to hash the input. Outputs in hex
export function hash (input: string): string {
	return sha256().update(input).digest('hex');
}
